const settings = {
  API_BASE_URL: "https://development.truetab.ai/api/v1",
};
export default settings;
